module.exports = __webpack_public_path__ + "img/exam.59773f61.png";